export const KEY = Symbol.for('di');
export const PACKAGE_NAME = 'react-magnetic-di';